<template>
    <div class="pt010" id="pt010" v-cloak>
      <div class="header-inner cf">
        <h1>
          <!--ロゴ画像-->
          <router-link :to="generateLinkParams(1,pt010RespModel.topPage)" @click.native="reload">
            <div class="logoImg" @error="getErrImage"></div>
          </router-link>
        </h1>
        <div id="nav-main">
          <ul class="nav-main-inner cf">
            <!-- ログアウト -->
            <li class="nav-login" v-if="isLoginFlg">
              <a v-if="!isExpiredPassword" href="javascript:void(0)" @click="doLogout">
                {{$t('common.buttons.logout')}}
              </a>
            </li>
            <!-- ログイン -->
            <li class="nav-login" v-else-if="loginHissuFlg">
              <router-link :to="generateLinkParams(18,pt010RespModel.loginPage)" @click.native="reload">
                {{$t('common.buttons.login')}}
              </router-link>
            </li>
            <!-- マイページ -->
            <li class="nav-mypage" v-if="isLoginFlg">
              <router-link :to="generateLinkParams(81,pt010RespModel.myPage)" @click.native="reload">
                {{$t('common.labels.myPgage')}}
              </router-link>
            </li>
            <!-- 会員登録 #73377:ログイン必須で承認不要だったら会員登録リンクを出さない-->
            <li class="nav-entry" v-if="loginHissuFlg && syoNinFlg  && !isLoginFlg ">
              <router-link :to="generateLinkParams(8,pt010RespModel.customerPage)" @click.native="reload">
                {{$t('pt010.labels.register')}}
              </router-link>
            </li>
            <!-- カートを見る -->
            <li class="nav-cart">
              <router-link :to="generateLinkParams(16,pt010RespModel.cartPage)" @click.native="reload">
                {{$t('pt010.labels.title')}}
                <strong class="itemQty">{{pt010.itemSu}}</strong>
              </router-link>
            </li>
            <!-- クーポン-->
            <li class="nav-coupon" v-if="ptInitData.couponFlg == '1' && isLoginFlg">
              <router-link :to="generateLinkParams(107, pt010RespModel.couponPage, { modeKbn: 0 })" @click.native="updateCouponKidoku">
                  <strong  class="newCouponQty">{{ ptInitData.newCouponQty }}</strong>
                  <span class="holdCouponQty">{{$t('pt010.labels.holdCouponQty')}}{{ ptInitData.holdCouponQty }}{{$t('pt010.labels.mai')}}</span>
              </router-link>
            </li>
            <!-- ポイント-->
            <li class="nav-point" v-if="ptInitData.pointFlg == '1' & isLoginFlg">
              <router-link :to="generateLinkParams(17,pt010RespModel.pointPage)" @click.native="reload">
                <span class="holdPointQty">{{$t('pt010.labels.holdPointQty')}}</span>
                <span id="customPoint" class="pointQty">0</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div id="nav-search">
          <!-- 商品検索 -->
          <template v-if="loginHissuFlg || isLoginFlg">
            <input id="nav-search-keyword" class="PT030_textItem" :title="$t('pt030.labels.productNm&ItemNum')" @keydown.enter="doSearch" type="text" name="itemNm" tabindex="-1" v-model="itemNm" size="15" maxlength="250" :placeholder="$t('pt030.labels.productSearch')">
            <input id="nav-search-button" :value="$t('common.buttons.search')" @click="doSearch" type="button">&nbsp;
            <input id="nav-search-button" :value="$t('common.labels.searchItemDetails')" @click="doSearchDetails" type="button">
          </template>
        </div>
      </div>
      <div id="top-head" ref="topHead" v-if="loginHissuFlg || isLoginFlg">
        <div class="inner">
          <div id="mobile-head" >
              <div id="nav-toggle" @click="toggleOpen">
                  <div>
                      <span>MENU</span>
                  </div>
              </div>
          </div>
          <!---mobile-head end -->
          <nav id="global-nav" role="navigation">
              <div id="gnav-container">
                  <ul id="gnav-ul" class="clearfix">
                    <!-- BtoCなら -->
                    <template>
                      <li>
                        <!-- トップページ -->
                        <router-link :to="generateLinkParams(1,pt010RespModel.topPage)" @click.native="reload">
                          {{$t('common.labels.homePage')}}
                        </router-link>
                      </li>
                      <li v-if="quickOrderFlg">
                        <!-- クイックオーダー-->
                        <router-link :to="generateLinkParams(6,pt010RespModel.quickPage)" @click.native="reload">
                          {{$t('pt395.labels.quickorder')}}
                        </router-link>
                      </li>
                      <li v-if="loginHissuFlg">
                        <!-- 初めての方へ -->
                        <router-link :to="generateLinkParams(1004,pt010RespModel.firstPage)" @click.native="reload">
                          {{$t('pt010.labels.guide')}}
                        </router-link>
                      </li>
                      <li v-if="infomationFlg">
                        <!-- お問合わせ -->
                        <router-link :to="generateLinkParams(4,pt010RespModel.callPage)" @click.native="reload">
                          {{$t('pt010.labels.question')}}
                        </router-link>
                      </li>
                    </template>
                  </ul>
              </div>
          </nav>
        </div>
    </div>
     <alert-confirm
      v-if="isShowAlert"
      v-bind:msgConfirm="$t('pt060.labels.msgConfirmLogout')"
      :okAction="_logout"
      @closedModal="isShowAlert = false"
      size="md"/>
    </div>
</template>

<script>
/*
 * Import libs and componnents
 */
import axios from "assets/js/request";
import common from "assets/js/common";
import SiteConstants from 'assets/const/SiteConstants.json';
import AlertConfirm from 'components/AlertConfirm';
export default {
  /*
   * Name of component
   */
  name: "PT010GrobalMenuParts",
  props:{
        evtChangeQtyFlg: {
            type: Boolean,
            default: false,
        },
        ptInitData: {
            type: Object,
            default: null,
        },
  },
  /*
   * Declare components
   */
  components: {
    AlertConfirm,
  },
  /*
   * Declare variable and set default value
   */
  data() {
    return {
      pt010: {
        itemSu: 0,
        optLogOutDelWKFlg:0
      },
      SiteConstants: SiteConstants,
      currentURL: sessionStorage.currentURL ? sessionStorage.currentURL : '',
      isShowAlert:false,
      listMessValid:[],
      mapMessValid:[],
      pt010ReqModel:{},
      pt010RespModel:{},
      sugList:[],
      itemNm:null,
      isToggle:false,
      site: "",
      isLoginFlg: false,
      loginHissuFlg : false,
      syoNinFlg : false,
      quickOrderFlg : false,
      infomationFlg :false,
      isExpiredPassword: false,
      suggestOptionFlg: false
    };
  },
  /*
   * Initialize
   */
  mounted() {
    var _this = this;
    _this.site = _this.$router.history.current.fullPath.split("/")[1];
    _this.currentURL = _this.$route.fullPath;
    if (_this.ptInitData){
      _this.pt010RespModel = _this.ptInitData;
      _this.pt010.itemSu = _this.ptInitData.reqModel.itemSu;
      _this.pt010.optLogOutDelWKFlg = _this.ptInitData.reqModel.optLogOutDelWKFlg;
      // 問合せフラグ
      if (_this.ptInitData.infomationFlg == 1){
        _this.infomationFlg = true;
      }
      // クイックオーダーフラグ
      if (_this.ptInitData.quickOrderFlg == 1) {
        _this.quickOrderFlg = true;
      }
      // ログイン必須フラグ／1：必須
      if (_this.ptInitData.loginHissuFlg == 1) {
        _this.loginHissuFlg = true;
      }
      //会員承認利用フラグ／0：否
      if (_this.ptInitData.syoNinFlg == 1) {
        _this.syoNinFlg = true;
      }
      // ログインフラグ
      if (_this.$Constants.GUEST_KOKYAKU_NO != _this.ptInitData.kokyakuNo) {
        _this.isLoginFlg = true;
      }
      // サジェスト機能利用オプション
      if (_this.ptInitData.suggestOptionFlg == 1) {
        _this.suggestOptionFlg = true;
      }
      _this.isExpiredPassword = _this.ptInitData.isExpiredPassword;
    }else{
      _this.init();
    }
    if (_this.ptInitData.pointFlg == 1) {
      api.f_point(_this.getCustomPoint);
    }
  },
  /*
   * Methods
   */
  methods: {

    getCustomPoint: function(result){
      if(result.pointDetailList != null && result.pointDetailList.length > 0){
        for(var i = 0; i < result.pointDetailList.length; i++) {
          var item = result.pointDetailList[i];
          var customPoint = document.getElementById("customPoint");
          if (customPoint){
            customPoint.innerHTML = item.POINT_NUM.toLocaleString() + 'pt';
          }
        }
      }
    },

    init: function(){
      var _this = this;
      //Call API to load init
      axios.get(_this.$UrlConstants.ECSITE +_this.$UrlConstants.PT010 + _this.$UrlConstants.DO_INIT)
        .then(function(response) {
          _this.pt010.itemSu = response.data.reqModel.itemSu;
          _this.pt010.optLogOutDelWKFlg = response.data.reqModel.optLogOutDelWKFlg;
          // 問合せフラグ
          if (response.data.infomationFlg == 1){
            _this.infomationFlg = true;
          }
          // クイックオーダーフラグ
          if (response.data.quickOrderFlg == 1) {
            _this.quickOrderFlg = true;
          }
          // ログイン必須フラグ／1：必須
          if (response.data.loginHissuFlg == 1) {
            _this.loginHissuFlg = true;
          }
          //会員承認利用フラグ／0：否
          if (response.data.syoNinFlg == 1) {
            _this.syoNinFlg = true;
          }
          // ログインフラグ
          if (_this.$Constants.GUEST_KOKYAKU_NO != response.data.kokyakuNo) {
            _this.isLoginFlg = true;
          }
          // サジェスト機能利用オプション
          if (response.data.suggestOptionFlg == 1) {
            _this.suggestOptionFlg = true;
          }
          _this.isExpiredPassword = response.data.isExpiredPassword;

        })
        .catch(function(error) {
          common.errorAPI(error);
      });
    },

    /*
    * 検索処理
    */
    doSearch: function(){
      var _this = this;
      if (common.isNullItem(_this.itemNm)){
        const parameter = _this.generateLinkParams(13, _this.pt010RespModel.searchDtlPage);
        _this.$router.push(parameter);
      } else {
        const parameter = _this.generateLinkParams(2, _this.pt010RespModel.productList, {searchItemNm: _this.itemNm});
        _this.$router.push(parameter);
      }
    },
    /*
    * サジェスト取得
    */
    async getSugList() {
      var _this = this;
      // 利用しないオプションの場合は作動しない
      if (!_this.suggestOptionFlg) {
        return;
      }
      _this.sugList = [];
        await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT010 + _this.$UrlConstants.DO_SEARCH, _this.pt010ReqModel).then(function(response){
          var suggestList = response.data.suggestList;
          if (suggestList != undefined && suggestList.length > 0) {
            for (var i = 0; i < suggestList.length; i++){
              var item = suggestList[i];
              _this.sugList[i] = item.WEB_ITEM_NM;
            }
          }
        }).catch(function(error){
            common.errorAPI(error);
        });
      return _this.sugList
    },

    /*
    * 詳細検索画面へ
    */
    doSearchDetails: function(){
      var _this =this;
      const parameter = _this.generateLinkParams(13, _this.pt010RespModel.searchDtlPage);
      _this.$router.push(parameter);
    },

    /*
    * クーポン既読フラグ更新 詳細検索画面へ
    */
    updateCouponKidoku: function(){
      var _this = this;
      axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT010 + _this.$UrlConstants.DO_UPDATE, _this.pt010ReqModel).then(function(response){
        _this.reload();
      }).catch(function(error){
        common.errorAPI(error);
      });
    },
    reload: function() {
      sessionStorage.currentURL = this.$route.fullPath;
      if (sessionStorage.currentURL == this.currentURL) {
        this.$router.go(0);
      }
    },

    getErrImage(event) {
      //get image default
      event.target.src = common.getImgDefault();
    },
    /*
    * ログアウト処理
    */
    doLogout: function(){
      var _this = this;
      // カートに何も入っていない場合
      if(_this.pt010.itemSu == 0 || _this.pt010.optLogOutDelWKFlg == 1){
          _this._logout();
      // カートに商品が入っている場合
      } else {
          _this.isShowAlert = true;
      }
    },
    /**
     * logout function
     */
    _logout: function(){
      var _this = this;
      _this.isShowAlert = false;
      //clear msg valid
      _this.listMessValid = [];
      _this.mapMessValid = [];
      common.clearMessageEcSite(_this.listIdErr,'pt010');
      _this.$emit("event-loading", true);
      // Call API login
      axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT060 + _this.$UrlConstants.LOGOUT).then(function(response) {
          if(response.data.status == 'OK'){
              //reset page
              var site = _this.$router.history.current.fullPath.split("/")[1];
              common.removeLocalStorageEcSite(site);
              _this.reload();
              const parameter = _this.generateLinkParams(1, _this.pt010RespModel.topPage);
              _this.$router.push(parameter);
          }
          _this.$emit("event-loading", false);
      }).catch(function(error) {
          _this.$emit("event-loading", false);
          // eslint-disable-next-line
          if(error != null && error != undefined){
              if(error.response != null && error.response != undefined){
                  if(406 == error.response.status){
                      var resultValid = common.excuteValidationEcSite(error,'pt010');
                      if(resultValid){
                          _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                          _this.listMessValid = resultValid.msgList;
                          _this.mapMessValid = resultValid.mapMsg;
                      }
                  }else{
                      common.errorAPI(error);
                  }
              }
          }
      });
    },
    toggleOpen: function(){
      var _this = this;
      let topHead = _this.$refs.topHead;
      if (_this.isToggle){
        topHead.className = "";
        _this.isToggle=false;
      }
      else {
        topHead.className = "open";
        _this.isToggle =true
      }
    },
    // ルーターリンクパラメータ設定
    generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
      return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
    }
  },
  watch: {
        /* eslint-disable */
        /**
         * get event change item order
         * @param {any} newVal, 
         * @param {any} oldVal
         */
        evtChangeQtyFlg(newVal, oldVal) {
            this.init();
        }
  },
  created(){
        var _this = this;
        _this.loginHissuFlg = false;
        _this.syoNinFlg = false;
        _this.isLoginFlg = false;
  }
};
</script>

